import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45cb9ed4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "SHOPPING LIST", -1))
const _hoisted_2 = { id: "shop-wrap" }
const _hoisted_3 = { id: "shop-form" }
const _hoisted_4 = { id: "shop-list" }
const _hoisted_5 = { class: "item-name" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "shop-item",
          placeholder: "Item Name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.text]
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args))),
          type: "submit",
          id: "shop-add"
        }, " Add ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: "item-row"
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item), 1),
            _createElementVNode("button", {
              class: "item-del",
              onClick: ($event: any) => (_ctx.deleteItem(index))
            }, "Delete", 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}